import { redirect } from '@tanstack/react-router';

import { authState } from '~/features/auth/state';
import type { UserRole } from '~/features/auth/types';

export const protectedRoute = (
  { roles = [] } = {} as { roles?: UserRole[] },
) => {
  const { accessToken, userInfo } = authState.get();

  // If no access token, redirect to login
  if (!accessToken) {
    throw redirect({
      to: '/login',
      replace: true,
    });
  }

  // If roles are specified, check if user has one of the roles
  if (roles.length > 0 && userInfo && !roles.includes(userInfo.role)) {
    throw redirect({
      to: '/',
      replace: true,
      search: (old) => ({ ...old, unauthorized: 1 }),
    });
  }
};

export const publicRoute = () => {
  const { accessToken } = authState.get();

  if (accessToken) {
    throw redirect({
      to: '/',
      replace: true,
    });
  }
};
